import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { usePersonalLoan } from 'shared/hooks';
import PaystubUpload from './PaystubUpload';
import UploadHoldingScreen from './UploadHoldingScreen';

const HOLDING_SCREEN_CONDITION = {
  paystub: (personalLoan) =>
    personalLoan.status?.manualPaystubUpload &&
    !personalLoan.status?.manualPaystubTasksComplete &&
    personalLoan.manualPaystubs?.some((paystub) => !paystub.completed),
};

const ManualUploadContainer = () => {
  const history = useHistory();
  const { type } = useParams();
  const { personalLoan } = usePersonalLoan();
  const [successfulSubmit, setSuccessfulSubmit] = useState(false);

  // TODO: make dynamic for when other document types require a holding screen
  const shouldDisplayHoldingScreen =
    successfulSubmit || HOLDING_SCREEN_CONDITION[type](personalLoan);

  if (shouldDisplayHoldingScreen) {
    return <UploadHoldingScreen type={type} plUuid={personalLoan.uuid} />;
  }

  return (
    <PaystubUpload
      type={type}
      onBack={() => history.push(`/applications/${personalLoan.uuid}/income/review`)}
      personalLoanUuid={personalLoan.uuid || ''}
      setSuccessfulSubmit={setSuccessfulSubmit}
    />
  );
};

export default ManualUploadContainer;
